// @flow

import type {$AxiosXHR} from 'axios';

import {fileManagerAPI as api} from '../../utils/api/file-storage-api';

export const uploadFile = (merchantId: number, file: File, scope: string = 'chargeback') => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('scope', scope);

  return api
    .post(`merchants/${merchantId}/files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then((response: $AxiosXHR<{fileId: string, fileName: string}>) => ({
      fileId: response.data.fileId,
      fileName: response.data.fileName
    }));
};

export const uploadMultipleFiles = async (merchantId: number, files: Array<File>) => {
  const uploadPromises = files.map(file => uploadFile(merchantId, file));
  return Promise.all(uploadPromises);
};
